import {graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import * as tracking from '../../tracking';
import {trackAndCommitMutation} from '../../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation attachProjectToProgramMutation($input: AttachProjectToProgramInput!) {
		attachProjectToProgram(input: $input) {
			program {
				node {
					id
					name
					description
					prefix
					color
					startDate
					endDate
					projects(first: 10000) @connection(key: "Program_projects", filters: []) {
						edges {
							node {
								id
								serviceCompanyId
								companyProjectId
								legacyProjectAsSingleProject {
									id
									customProjectId
								}
								name
								prefix
								color
								startDate
								endDate
								stage
								clients {
									edges {
										node {
											id
											name
											logoId
										}
									}
								}
								status {
									edges {
										node {
											id
											description
											color
											addedAt
										}
									}
								}
								currentProjectStatus {
									id
									color
									description
									person {
										id
										firstName
										lastName
										profilePictureId
									}
								}
								financialNumbers {
									allActualTimeAndExpenses
									recognitionProfitPercentage
									allTotalTimeAndExpensesAtCompletion
								}
								financialNumbersToDate {
									recognitionProfitPercentage
								}
								totalRevenueRecognition
								totalRevenueRecognitionToDate
								totalTimeRevenueRecognitionToDate
								totalBillableExpensesAtCompletion
								settings {
									edges {
										node {
											id
											name
											value
										}
									}
								}
								userRelationTypes
							}
						}
					}
					projectsFinancialsTotals {
						recognitionForecastRevenue # Revenue - Recognition at completion
						allActualTimeAndExpenses # Spend - Actual to date
						allTotalTimeAndExpensesAtCompletion # Spend - Total at completion
						recognitionProfitPercentage # Profit margin - total at completion
						recognitionActualProfitPercentage # Profit margin - total at completion
					}
					projectsFinancialsToDate {
						totalActualRevenueRecognition # Revenue - recognised to date
						recognitionAmount # Revenue - recognised to date
						recognitionActualProfitPercentage # Profit margin - actual to date
						allActualTimeAndExpenses # Spend - actual to date
					}
				}
			}
		}
	}
`;

function getConfigs(input) {
	return [
		{
			type: 'RANGE_ADD',
			parentID: input.programId,
			connectionInfo: [
				{
					key: 'Program_projects',
					rangeBehavior: 'append',
				},
			],
			edgeName: 'projects',
		},
	];
}

function commit(environment, input, onSuccess, onError, uploadables) {
	tracking.trackEvent('Attached project to program');
	const {companyId, ...cleanedInput} = input;

	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...cleanedInput}};

	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		uploadables,
		configs: getConfigs({companyId, ...cleanedInput}),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
